import React from 'react';
import { Message } from '../message';
import { MessageImplementationProps, MessageVariant } from '../message/message';

export type BannerProps = MessageImplementationProps & {
  variant?: Omit<MessageVariant, 'transparent'>;
};

export const Banner = (props: BannerProps) => <Message cssBlockName="airtame-banner" {...props} />;

Banner.displayName = 'Banner';
